import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-registration-completed',
  templateUrl: './registration-completed.component.html',
  styleUrls: ['./registration-completed.component.css']
})
export class RegistrationCompletedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


  // qsppWebsite(){
  //  (window as any).location="https://www.qspp.com";
  // }

  // qsppPortal(){
  //    (window as any).location="https://portal.qspp.com";
  // }



  //Stage
  qsppWebsite(){
          (window as any).location="https://qspp.com/";
        }

  qsppPortal(){
          (window as any).location="https://qsppstaging.microsoftcrmportals.com/pharmacy/";
        }



//prod
   qcppPortal(){
    (window as any).location="https://portal.qspp.com";
  }





        
}
